import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import api from 'api'
import constants from '../constants'
import { withTranslation } from 'react-i18next'

@inject('uiStore', 'selectionStore', 'dataStore') @observer
class DataUpdateInfoModal extends Component {
  async handleClose (userId) {
    const response = await api.recalculateUserPolygons(userId)
    const responseData = response.data
    if (responseData.success) {
      this.props.uiStore.dataUpdateInfoModal = false
    }
  }

  render () {
    const { uiStore: { dataUpdateInfoModal } } = this.props
    const { t } = this.props
    if (!dataUpdateInfoModal) {
      return null
    }
    return (
      <div className='dataupdate-modal-section'>
        <div className='modal-overlay' onClick={this.handleClose(this.props.uiStore.user.id)} />
        <div className='modal-section' onClick={(e) => e.stopPropagation()}>
          <button type='button' className='modal-section--button' onClick={this.handleClose(this.props.uiStore.user.id)}>&times;</button>
          <p className='modal-section--header'>
            <b className='modal-section--header-heading'>{t('DATA_UPDATE_INFO_MODAL.TITLE')}</b>
          </p>
          <div className='modal-section--message'>
            <p className='modal-section--content-dataupdate'>
              <b>{t('DATA_UPDATE_INFO_MODAL.TEXT_FIRST_PARAGRAPH')}</b>
            </p>
            <p className='modal-section--content-dataupdate'>
              <svg xmlns='http://www.w3.org/2000/svg' width='3em' height='3em' viewBox='0 0 24 24'>
                <path fill='#60C556' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                  <animateTransform attributeName='transform' dur='2.25s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                </path>
              </svg>
            </p>
          </div>
          <p className='modal-section--content-dataupdate'>{t('DATA_UPDATE_INFO_MODAL.TEXT_SECOND_PARAGRAPH')}</p>
          <div>
            <a href={constants.SERVICE_DESK_URL} style={{ textDecoration: 'none' }} target='_blank' rel='noreferrer'>
              <button className='upgrade-dataupdate-button'>{t('DATA_UPDATE_INFO_MODAL.BUTTON_TEXT')}</button>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(DataUpdateInfoModal)
